import React from "react";

function PageLoader() {
  return (
    <div className="absolute top-0   w-full h-screen flex pt-64 justify-center">
      <div className="guest-web-page-loader relative"></div>
    </div>
  );
}

export default PageLoader;
